import {
  BTC,
  ETH,
  JITO_SOL,
  JUP,
  MER,
  M_SOL,
  PYTH,
  RAY,
  RENDER,
  RE_NGN,
  SBR,
  SOL,
  SO_FTT,
  SRM,
  ST_RENEC,
  USDC,
  USDT,
  VND,
  WBTC,
} from "@renec-foundation/relend-adapter"

export const LIST_SYMBOLS_USING_SYMBOL_TO_DISPLAY = [
  RE_NGN,
  ST_RENEC,
  SBR,
  BTC,
  RAY,
  USDC,
  SO_FTT,
  SRM,
  MER,
  ETH,
  M_SOL,
  SOL,
  USDT,
  VND,
  WBTC,
  RENDER,
  PYTH,
  JUP,
  JITO_SOL,
]

export class RplToken {
  static getTokenDisplayName(symbol: string, name: string) {
    return LIST_SYMBOLS_USING_SYMBOL_TO_DISPLAY.includes(symbol) ? symbol : name
  }
}
